import { WidgetsAbstract } from "./widgets.abstract";

export abstract class WidgetsContainerAbstract extends WidgetsAbstract {
    isContainerExpanded: boolean = true;
    abstract children: WidgetsAbstract[];
}
